<template>
  <div class="wrap">
    <div class="leftBox">
      <img-box class="box" :imgSrc="dynamicImg.sumInfoExport" :activeImg="dynamicImg.sumInfoExportAct" title="汇总上传"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.remortCardClear" :activeImg="dynamicImg.remortCardClearAct" title="远程清卡"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.sumUpload" :activeImg="dynamicImg.sumUploadAct" title="汇总资料传出"></img-box>
      <div class="toRightImg">
        <img :src="dynamicImg.toRight" alt="" />
      </div>
    </div>
    <div class="rightBox">
      <img-box class="box" :imgSrc="dynamicImg.statusQuery" :activeImg="dynamicImg.statusQueryAct" title="金税设备状态查询"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.staticsSum" :activeImg="dynamicImg.staticsSumAct" title="金税设备资料统计"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.printing" :activeImg="dynamicImg.printingAct" title="发票资料查询打印"></img-box>
      <img-box class="box" :imgSrc="dynamicImg.invoiceExport" :activeImg="dynamicImg.invoiceExportAct" title="发票数据导出"></img-box>
    </div>
  </div>
</template>

<script>
import ImgBox from '@/components/ImgBox/Index'
import { dynamicImg } from '@/utils/dynamicImg'
export default {
  components: {
    ImgBox,
  },
  data() {
    return {
      dynamicImg,
    }
  },
  created() {},
}
</script>

<style lang="less" scoped>
.boxparam {
  flex-basis: 45%;
  background-color: #fff;
  display: flex;
  flex-wrap: wrap;
  border-radius: 20px;
  height: 70%;
  align-items: center;
  .box {
    width: 50%;
  }
}
.wrap {
  width: 900px;
  // height: 600px;
  height: 93%;
  display: block;
  position: relative;
  // border: 1px solid;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.leftBox {
  .boxparam();
  position: relative;
  .toRightImg {
    position: absolute;
    transform: translate(-50%, -50%);
    left: 50%;
    top: 25%;
  }
}
.rightBox {
  .boxparam();
}
</style>
